// extracted by mini-css-extract-plugin
export default {"loader":"loader-spinner_loader__unpsk","spin":"loader-spinner_spin__7doQW"};